module.exports = __webpack_public_path__ + "static/media/autocomplete.72770204.png";